import { PortableTextProjection } from '@lib/sanity/types/common';

export type TitleType =
  | undefined
  | {
      _type: string;
      children: {
        _key: string;
        _type: string;
        text: string;
        marks: string[];
      }[];
      _key?: string | undefined;
      markDefs?: {
        _type: string;
        _key: string;
      }[];
      style?: string | undefined;
      listItem?: string | undefined;
      level?: number | undefined;
    }[];

export type InternationalizedTitleType = { value: TitleType }[];
export default function getProtableText(titleValue?: PortableTextProjection) {
  if (!titleValue?.value?.length) {
    return [''];
  }
  // if no title exists, return empty string
  if (!Array.isArray(titleValue.value) || !titleValue.value?.some((x) => x.children?.some((x) => x.text))) {
    return '';
  }

  // if title exists
  // return title as text from all lines inside the title field (lines and colored words included)
  return titleValue.value.map((lineInTitle) =>
    lineInTitle.children?.map((x) => x.text).reduce((a, b) => (a ?? '') + (b ?? '')),
  );
}
